import React from 'react';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider, } from '@mui/material';
import StylesProvider from '@mui/styles/StylesProvider';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { createGenerateClassName } from '@mui/styles';
import useDefaultTheme from '@innovyze/stylovyze/lib/hocs/ApplicationWrapper/theme/themes/useDefaultTheme';
import { innovyzeTheme } from '@innovyze/stylovyze/lib/hocs/ApplicationWrapper/theme/themes/innovyzeTheme';
// weave
import ThemeContext from '@weave-design/theme-context';
import { useWeaveThemeConsumer } from './WeaveContext';
export default function InnoStylesProvider({ children, theme, hasWeaveTheme = false, }) {
    const generateClassName = createGenerateClassName({
        productionPrefix: 'inno',
    });
    const { isWeaveActive } = useWeaveThemeConsumer();
    if (hasWeaveTheme) {
        return (React.createElement(ThemeContext.Consumer, null, ({ resolvedRoles, metadata }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const resolvedTheme = useDefaultTheme({
                theme,
                weave: { resolvedRoles, metadata },
                isWeaveActive,
            });
            return (React.createElement(StylesProvider, { injectFirst: true, generateClassName: generateClassName },
                React.createElement(StyledEngineProvider, { injectFirst: true },
                    React.createElement(MuiThemeProvider, { theme: resolvedTheme },
                        React.createElement(StyledComponentsThemeProvider, { theme: resolvedTheme }, children)))));
        }));
    }
    const selectedTheme = theme || innovyzeTheme;
    return (React.createElement(StylesProvider, { injectFirst: true, generateClassName: generateClassName },
        React.createElement(StyledEngineProvider, { injectFirst: true },
            React.createElement(MuiThemeProvider, { theme: selectedTheme },
                React.createElement(StyledComponentsThemeProvider, { theme: selectedTheme }, children)))));
}
